import React, {ReactElement, ReactNode} from 'react'

import ModalComponent from "@ui/modal/ModalComponent";
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    component: ReactElement,
    button: ReactElement,
    label?: string,
    initialFullScreenMode?: boolean,
    initialOpen?: boolean,
    empty?: boolean,
    hideFullScreenToggle?: boolean,
    headerSx?: SxType,
    closeMenuFn?: () => void,
    onOpen?: () => void,
    onClose?: () => void,
    children?: ReactNode,

}

const ModalCustom = React.forwardRef(({
                                          button,
                                          component,
                                          label,
                                          children,
                                          initialFullScreenMode,
                                          initialOpen,
                                          empty,
                                          hideFullScreenToggle,
                                          headerSx,
                                          closeMenuFn,
                                          onOpen,
                                          onClose,
                                      }: IProps, ref) => {

    const modalRef = React.useRef(null);

    React.useImperativeHandle(ref, () => ({
        closeModal() {
            if (modalRef) {
                modalRef.current.closeModal();
            }
        },
        openModal() {
            if (modalRef) {
                modalRef.current.openModal();
            }
        },

    }), [modalRef]);

    const closeModalFn = () => {
        if (modalRef.current.closeModal) {
            modalRef.current.closeModal();
        }
    };


    return (
        <ModalComponent
            ref={modalRef}
            button={button}
            label={label}
            initialFullScreenMode={initialFullScreenMode}
            initialOpen={initialOpen}
            empty={empty}
            hideFullScreenToggle={hideFullScreenToggle}
            headerSx={headerSx}
            onOpen={onOpen}
            onClose={onClose}
        >

            {component ? React.cloneElement(component, {
                    closeModalFn,
                    closeMenuFn,
                })
                : children
            }
        </ModalComponent>

    );
})


export default ModalCustom;